<template>
<v-app id="inspire">

    <v-main style="background-color: #24292d;font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

  <v-container fluid fill-height align-start>

    <v-row  >
      <v-col md="12" lg="12" cols="12">
        <v-alert
        :value="alertborrador"
        color="red"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Fiesta se borro con éxito.
       </v-alert>
       <v-alert
        :value="alertnuevo"
        color="primary"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Fiesta se agrego con éxito.
       </v-alert>
       <v-alert
        :value="alerteditar"
        color="green"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Fiesta se edito con éxito.
       </v-alert>
        <h1 class="text-h3 text-center"  style="color: #FFFFFF;font-family: 'Poppins', sans-serif !important;">Fiestas</h1>
        <p class="text-h6 text-center"  style="color: #FFFFFF;font-family: 'Poppins', sans-serif !important;">Se muestran las últimas 10 fiestas por default, si quieres ver todo el historial dar click en Ver Historial</p>
        <div  style="color: #393E46;">
          <v-switch   color="#393E46"  v-model="vistatabla">
            <template v-slot:label>
              <span style="color: #FFFFFF;">Ver Como Tabla</span>
            </template>
          </v-switch>
        </div>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on"><span class="hidden-sm-only hidden-xs-only">Nueva Fiesta</span><v-icon class=" hidden-md-only hidden-lg-only hidden-xl-only">fas fa-plus</v-icon></v-btn>
          </template>
          <v-card color="#393E46">
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" lg="12" md="12">
                    <v-text-field ref="nombreacto" :counter="50" type="text" v-model="editedItem.nombre" label="Nombre" ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" lg="12" md="12">
                    <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="editedItem.fechaInicio" label="Fecha"
                                      hint="YYYY-MM-DD" persistent-hint
                                      @blur="date = editedItem.fechaInicio"
                                      v-on="on"
                                      prepend-icon="fas fa-calendar" ></v-text-field></template>
                      <v-date-picker
                          v-model="date"
                          no-title
                          min="1950-01-01"
                          @input="menu1 = false"
                          @change="editedItem.fechaInicio = date"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                    <v-col cols="12" sm="12" md="12" lg="12">
                        <v-switch v-model="editedItem.sinLimite" label="Sin Limite de Cierre de Listas de Promotores"></v-switch>
                    </v-col>
                    <v-col v-if="!editedItem.sinLimite" cols="12" sm="12" md="12" lg="12">
                      <v-row>
                        <v-col cols="12">Horario de Cierre de Listas para los Promotores</v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <v-autocomplete
                              v-model="lahora"
                          :items="horas"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                          <v-autocomplete
                              v-model="elmin"
                          :items="minutos"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-col>


                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialoguploadimage"  persistent max-width="600">
          <v-card>
            <v-card-title class="headline">Subir nuevo Flyer?</v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="12" lg="12" cols="12">
                  <v-img :src="editedItem.flyer"  />
                </v-col>
                <v-col md="12" lg="12" cols="12">
                  <v-file-input
                      label="Subir Archivo"
                      accept="image/*"
                      filled
                      chips
                      v-model="imagen"
                      @change="onFileChange"
                      prepend-icon="mdi-camera"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="dialoguploadimage=false">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialoguploadlogo"  persistent max-width="600">
          <v-card>
            <v-card-title class="headline">Subir nuevo Logo QR?</v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="12" lg="12" cols="12">
                  <v-img :src="editedItem.logoQr"  />
                </v-col>
                <v-col md="12" lg="12" cols="12">
                  <v-file-input
                      label="Subir Archivo"
                      accept="image/*"
                      filled
                      chips
                      v-model="imagen"
                      @change="onFileChangeLogo"
                      prepend-icon="mdi-camera"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="dialoguploadlogo=false">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogdelete" persistent max-width="350">
          <v-card>
            <v-card-title class="headline">Desea eliminar esta Fiesta?</v-card-title>
            <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="close">No</v-btn>
              <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-btn color="warning" class="ml-5 mb-2" @click="damefiestastodas"><span class="hidden-sm-only hidden-xs-only">Ver Historial</span> <v-icon class=" hidden-md-only hidden-lg-only hidden-xl-only">fas fa-history</v-icon></v-btn>
       <div v-if="vistatabla===false">
<v-row>
  <v-col cols="12" md="3" lg="3" sm="12"
  v-for="fiesta in fiestas" :key="fiesta.id"
  >

    <v-card color="#393E46" elevation="10">
<v-card-title style=" overflow:hidden;
    white-space:nowrap;
    text-overflow: ellipsis;">{{fiesta.nombre}}</v-card-title>
      <v-card-text>
        <v-row justify="center">
          <v-col lg="6" md="6" sm="12">
        <div v-if="fiesta.foto===''">
          <v-img height="200" src="@/assets/sinimagen.jpeg" />
        </div>
        <div v-else>
            <v-img height="200" :src="fiesta.foto"></v-img>
        </div>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" lg="12" align="center" >
       <h3>  {{fiesta.dia.dia}},{{formatFechasd(fiesta.fechaInicio)}}</h3>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col>
            <v-icon
                small
                color="blue"
                class="mr-2"
                @click="editItem(fiesta)"
            >
              fas fa-edit
            </v-icon>   </v-col>
          <v-col>  <v-icon
                small
                class="mr-2"
                color="error"
                @click="deleteItem(fiesta)"
            >
              fas fa-minus-circle
            </v-icon> </v-col>
          <v-col>   <v-icon
                small
                class="mr-2"
                color="yellow"
                @click="flyerItem(fiesta)"
            >
              fas fa-photo-video
            </v-icon>
          </v-col>
          <v-col>   <v-icon
              small
              class="mr-2"
              color="green"
              @click="logoqrItem(fiesta)"
          >
            fas fa-qrcode
          </v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-col>
</v-row>
        </div>

<div v-else-if="vistatabla===true">
        <v-data-table
      :headers="headers"
      :items="fiestas"
      sort-by="Fecha"
      sort-desc
      class="elevation-1"
      :search="search"
      :loading="progr"
      no-data-text="No hay datos disponibles para mostrar."
      no-results-text="No hay resultados para la búsqueda."
      loading-text="Cargando... Por favor espere."
      style="background-color: #393E46;"
    >
      <template v-slot:top>
        <v-toolbar flat >
          <v-toolbar-title class="hidden-sm-only hidden-xs-only">Fiestas</v-toolbar-title>
          <v-btn @click="damefiestas"><v-icon>fas fa-sync-alt</v-icon></v-btn>

          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
          <v-spacer></v-spacer>

        </v-toolbar>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          color="primary"
          v-bind="attrs"
          v-on="on"
          class="mr-2"
          @click="editItem(item)"
        >
          fas fa-edit
        </v-icon>
          </template>
          <span>Actualiza Fiesta</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          class="mr-2"
          color="error"
          v-bind="attrs"
          v-on="on"
          @click="deleteItem(item)"
        >
          fas fa-minus-circle
        </v-icon>
          </template>
          <span>Borrar Fiesta</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
            small
            class="mr-2"
            color="yellow"
            v-bind="attrs"
            v-on="on"
            @click="flyerItem(item)"
        >
          fas fa-photo-video
        </v-icon>
          </template>
          <span>Subir Flyer</span>
        </v-tooltip>
      </template>
          <template v-slot:[`item.publicoapp`]="{ item }">
            <v-switch v-model="item.publicoapp" @click="activaListaItem(item)" ></v-switch>
          </template>
      <template v-slot:[`item.activo`]="{ item }">
        <v-switch v-model="item.activo" @click="activaListaItem(item)" ></v-switch>
      </template>
      <template v-slot:[`item.diactiva`]="{ item }">
        <v-switch v-model="item.diactiva" @click="activaListaItem(item)"   ></v-switch>
      </template>
            <template v-slot:[`item.dsinlimite`]="{ item }">
                <v-switch v-model="item.sinLimite" @click="activaListaItem(item)"   ></v-switch>
            </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="damefiestas">Cargar de Nuevo</v-btn>
      </template>
          <template v-slot:[`item.fecha`]="{ item }">
            {{formatFechasd(item.fechaInicio)}}
          </template>
    </v-data-table>
</div>
      </v-col>
    </v-row>
    <leftmenu :abreviado="abreviado" />
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"

      />
    </v-overlay>
  </v-container>
    </v-main>
  </v-app>
</template>
<style>
.dropzone-custom-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.dropzone-custom-title {
  margin-top: 0;
  color: #00b782;
}

.subtitle {
  color: #314b5f;
}
</style>
<script>
import { mapGetters } from "vuex";
import leftmenu from '../../general/leftmenu';
import axios from 'axios';
import moment from "moment-timezone";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  title: 'Fiestas | Tunay Mi acceso de bolsillo',

  components: {
    Cabecerabaja,
    leftmenu

  },
    data: () => ({
      drawer: null,
      idnegocio: 0,
      negocio: {},
      lahora:'20',
      elmin:'00',
      imagen : null,
      token:'',
      time: null,
      menu3: false,
      modal3: false,
      horas:[],
      minutos:[],
      progr: true,
      alertborrador: false,
      alertnuevo: false,
      alerteditar: false,
      dialog: false,
      dialogdelete: false,
      overlay: false,
      date: new Date().toISOString().substr(0, 10),
              menu1: false,
      dialoguploadimage: false,
      dialoguploadlogo:false,
      vistatabla: false,
      fiestas: [],
      abreviado:'',
      temporada:{},
      search: '',
      editedIndex: -1,
      editedItem: {
        id: 0,
        activo: true,
        aforo: 0,
        cabecera: '',
        cliente: null,
        createdAt: null,
        descripcion: '',
        dia: {},
        diactiva: true,
        horaPromotorCierre: null,
        fechaFinal: null,
        fechaInicio: new Date().toISOString().substr(0, 10),
        flyer: '',
        footer: '',
        foto: '',
        horaFinal: null,
        horaInicio: '22:00:00',
        lat: '',
        listaapp: true,
        lng:'',
        nombre:'',
        promotorcambia:false,
        publicoapp: true,
        qrmail:false,
        tag: '',
        temporada: {},
        ubicacion:'',
        bgQrColor:'#000000',
        logoQr:'',
        ventapp: false,
          entradasVenta:false,
          sinLimite: false
    },
    defaultItem: {
      id: 0,
      activo: true,
      aforo: 0,
      cabecera: '',
      cliente: null,
      createdAt: null,
      descripcion: '',
      horaPromotorCierre: null,
      dia: {},
      diactiva: true,
      fechaFinal: null,
      fechaInicio: new Date().toISOString().substr(0, 10),
      flyer: '',
      footer: '',
      foto: '',
      horaFinal: null,
      horaInicio: '22:00:00',
      lat: '',
      listaapp: true,
      lng:'',

      bgQrColor:'#000000',
      negocio:{},
      nombre:'',
      promotorcambia:false,
      publicoapp: true,
      qrmail:false,
      tag: '',
      temporada: {},
      ubicacion:'',
      ventapp: false
    },
headers: [
                { text: 'Acciones', value: 'action', sortable: false },
        { text: 'Fiesta', align: 'left',  value: 'nombre'},
        { text: 'Fecha', value: 'fecha' },

  { text: 'Hora Cierre Listas', value: 'horaPromotorCierre' },
        { text: 'Dia', value: 'dia.dia' },
  { text: 'Pública', value: 'publicoapp', sortable: false },
              { text: 'Lista', value: 'activo', sortable: false },
              { text: 'Dia', value: 'diactiva', sortable: false },
    { text: 'Sin Limite', value: 'dsinlimite', sortable: false },

      ]
  }),
  mounted (){
        this.idnegocio =  this.$route.params.idnegocio
         this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
    this.horas = []
    this.minutos = []
    for (let i = 0; i<=60;i++){
      this.minutos.push(i.toString().padStart(2, '0'))
    }

    for (let j = 0; j<=23;j++){
      this.horas.push(j.toString().padStart(2, '0'))
    }
        this.overlay = true
    if (this.usuario.id === undefined){
      this.overlay = true
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.overlay = false
              this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

              this.damefiestas();
            }else{
              this.overlay = false
              this.$router.push({ path: '/' });
            }
          })

        }else{
      this.overlay = false
      this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
      this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

      this.damefiestas();
      this.defaultItem.fechaInicio = this.formatDate(this.date);
      this.editedItem.fechaInicio = this.formatDate(this.date);

    }
  },
   watch: {
    dialog (val) {
      val || this.close()
    },
     "$store.state.usuario": function (){
       if (this.usuario.id === undefined){
         this.$router.push({ path: '/' });
       }else{
       this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;
       this.damefiestas();
       this.defaultItem.fechaInicio = this.formatDate(this.date);
       this.editedItem.fechaInicio = this.formatDate(this.date);}
     },
    "$route.params.idnegocio"(value) {
          console.log(value);
           this.idnegocio =  this.$route.params.idnegocio
        this.editedItem = this.defaultItem
                     this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
                                 if (this.usuario.id === undefined){
                                   this.$router.push({ path: '/' });
           }else{

                                   this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

                                   this.damefiestas();
                 }
    },
    date () {
      this.editedItem.fecha = this.formatDate(this.date)
    },
  },
  methods : {
    formatFechasd(value) {
      var fec = moment(value).locale('es-pe');

      return fec.tz(this.negocio.cliente.timeZone.timeZone).format("DD MMMM YYYY")
    },
    reload( response){
      console.log(response);
      this.damefiestas()
    },
    formatTime (date) {
      let hora = new Date('2020-10-10 '+date)
      return moment(hora).locale('es-pe').format("HH:mm");
    },
    formatDateee(value) {
      var fec = moment(value).locale('es-pe');

      return fec.tz(this.negocio.cliente.timeZone.timeZone).format("YYYY-MM-DD hh:mm:ss")
    },
      formatDate (date) {
      return moment(date).locale('es-pe').format("YYYY-MM-DD");
    },
    dametemporadaactiva(){
      this.progr = true;
      this.overlay = true
      let urlfiesta = 'temporadas/negocio/activa/' + this.negocio.id ;
      axios
          .get(urlfiesta,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.temporada = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alenprteditar = false;
            this.overlay = false
          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false;
            this.progr = false;
          });
    },
    formatDarete (date) {
      var fec = moment(date).locale('es-pe');
      return fec.tz(this.negocio.cliente.timeZone.timeZone).format("DD-MM-YYYY");
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    damefiestas(){
      this.progr = true;
      this.overlay = true
            let urlfiesta = 'actos/fiestas/negociotag/' + this.idnegocio ;
        axios
        .get(urlfiesta,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
            this.fiestas = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            this.overlay = false

          this.dametemporadaactiva();
        })
        .catch((error)  => {
        console.log(error);
          this.progr = false;
        this.overlay = false
        });
    },
    damefiestastodas(){
      this.progr = true;
      this.overlay = true
      let urlfiesta = 'actos/fiestas/negociotag/' + this.idnegocio +'/all' ;
      axios
          .get(urlfiesta,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.fiestas = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            this.overlay = false

            this.dametemporadaactiva();
          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false
            this.progr = false;
          });
    },
    editItem (item) {
      this.editedIndex = this.fiestas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      this.lahora = this.editedItem.horaPromotorCierre.toString().substr(0,2)
      this.elmin = this.editedItem.horaPromotorCierre.toString().substr(3,2)
    },
    activaListaItem (item) {
      this.editedItem = Object.assign({}, item);
      this.editedItem.fechaInicio = this.formatDarete(new Date(this.editedItem.fechaInicio+"T00:00:00"))
      this.editedItem.fechaFinal = this.formatDarete(new Date(this.editedItem.fechaFinal+"T00:00:00"))

      if(this.editedItem.createdAt !== null){
      this.editedItem.createdAt = this.formatDateee(new Date(this.editedItem.createdAt))}
      if(this.editedItem.temporada.createdAt !== null){
      this.editedItem.temporada.createdAt = this.formatDateee(new Date(this.editedItem.temporada.createdAt))}
      if(this.editedItem.temporada.negocio.cliente.createdAt !== null){
      this.editedItem.temporada.negocio.cliente.createdAt = this.formatDateee(new Date(this.editedItem.temporada.negocio.cliente.createdAt))}
      this.overlay = true
      var bodyFormData = new FormData();
      bodyFormData.append("data",JSON.stringify(this.editedItem));
      axios
      .post('actos/fiestas/grabar',bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response => {
            this.fiestas = response.data
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            this.overlay = false
          })
            .catch(error => {
                    this.error = "Hubo un error";
              this.overlay = false
                    console.error(error);
                });
    },
    onFileChange(e) {
         this.editedItem.flyer= URL.createObjectURL(this.imagen)
      var bodyFormData = new FormData();
      bodyFormData.append("file",this.imagen);
      let url = "actos/fiestas/flyer/" + this.editedItem.id
      this.overlay = true
      axios
          .post(url,bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.dialoguploadimage = false;
            this.overlay = false;
            console.assert(true,response);
              this.damefiestas()
          })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
          });
      console.log(e)
    },
    onFileChangeLogo(e) {
      this.editedItem.logoQr= URL.createObjectURL(this.imagen)
      var bodyFormData = new FormData();
      bodyFormData.append("file",this.imagen);
      let url = "actos/fiestas/logoqr/" + this.editedItem.id
      this.overlay = true
      axios
          .post(url,bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.dialoguploadlogo = false;
            this.overlay = false;
            console.assert(true,response);
            this.damefiestas()
          })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
          });
      console.log(e)
    },

    activaFiestaItem (item) {
      this.editedItem = Object.assign({}, item)
      this.editedItem.fechaInicio = this.formatDarete(new Date(this.editedItem.fechaInicio+"T00:00:00"))
       if(this.editedItem.createdAt !== null){
         this.editedItem.createdAt = this.formatDateee(new Date(this.editedItem.createdAt))}
       if(this.editedItem.temporada.createdAt !== null){
         this.editedItem.temporada.createdAt = this.formatDateee(new Date(this.editedItem.temporada.createdAt))}
      this.overlay = true
      var bodyFormData = new FormData();
      bodyFormData.append("data",JSON.stringify(this.editedItem));
      axios
      .post('actos/fiestas/grabar',bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response => {
            this.fiestas = response.data
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            this.overlay = false
          })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
    },
    deleteItem (item) {
      this.editedIndex = this.fiestas.indexOf(item);
      this.dialogdelete = true;
    },
    flyerItem (item) {
      this.editedIndex = this.fiestas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.fechaInicio = this.formatDarete(new Date(this.editedItem.fechaInicio+"T00:00:00"))
      if(this.editedItem.createdAt !== null){
        this.editedItem.createdAt = this.formatDateee(new Date(this.editedItem.createdAt))}
      if(this.editedItem.temporada.createdAt !== null){
        this.editedItem.temporada.createdAt = this.formatDateee(new Date(this.editedItem.temporada.createdAt))}
      if(this.editedItem.temporada.negocio.cliente.createdAt !== null){
        this.editedItem.temporada.negocio.cliente.createdAt = this.formatDateee(new Date(this.editedItem.temporada.negocio.cliente.createdAt))}
    //  this.dropOptions.url = "https://i45z56jzhf.execute-api.us-east-1.amazonaws.com/prod/fiestas/flyer/" + this.editedItem.fiestaId
      this.dialoguploadimage = true
    },
    logoqrItem (item) {
      this.editedIndex = this.fiestas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.fechaInicio = this.formatDarete(new Date(this.editedItem.fechaInicio+"T00:00:00"))
      if(this.editedItem.createdAt !== null){
        this.editedItem.createdAt = this.formatDateee(new Date(this.editedItem.createdAt))}
      if(this.editedItem.temporada.createdAt !== null){
        this.editedItem.temporada.createdAt = this.formatDateee(new Date(this.editedItem.temporada.createdAt))}
      if(this.editedItem.temporada.negocio.cliente.createdAt !== null){
        this.editedItem.temporada.negocio.cliente.createdAt = this.formatDateee(new Date(this.editedItem.temporada.negocio.cliente.createdAt))}
      //  this.dropOptions.url = "https://i45z56jzhf.execute-api.us-east-1.amazonaws.com/prod/fiestas/flyer/" + this.editedItem.fiestaId
      this.dialoguploadlogo = true
    },
    borralo (){
      this.overlay = true
      this.dialogdelete = false;
      axios
      .delete('actos/fiestas/'+ this.fiestas[this.editedIndex].id,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
      .then(response => {
        console.assert(true,response);

        this.alertborrador = true;
        this.damefiestas();
        this.overlay = false
                })
      .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
        this.overlay = false
                });
    },
    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      this.overlay = true
      if (this.editedIndex > -1) {
        Object.assign(this.fiestas[this.editedIndex], this.editedItem);
        let Xmas95 = new Date(this.editedItem.fechaInicio+"T00:00:00");
        let eldia = Xmas95.getUTCDay();
        if(eldia ===0 ){
          eldia=7
        }
        let diaDt = this.dias.find(x=>x.id === eldia);
        this.editedItem.dia=diaDt;
        this.editedItem.fechaInicio = this.formatDarete(new Date(this.editedItem.fechaInicio+"T00:00:00"))
        this.editedItem.fechaFinal = this.formatDarete(new Date(this.editedItem.fechaFinal+"T00:00:00"))
        this.editedItem.horaPromotorCierre = this.lahora + ":" + this.elmin + ":00"
        if(this.editedItem.createdAt !== null){
          this.editedItem.createdAt = this.formatDateee(new Date(this.editedItem.createdAt))}
        if(this.editedItem.temporada.createdAt !== null){
          this.editedItem.temporada.createdAt = this.formatDateee(new Date(this.editedItem.temporada.createdAt))}
        if(this.editedItem.temporada.negocio.cliente.createdAt !== null){
          this.editedItem.temporada.negocio.cliente.createdAt = this.formatDateee(new Date(this.editedItem.temporada.negocio.cliente.createdAt))}

        var bodyFormData2 = new FormData();
        bodyFormData2.append("data",JSON.stringify(this.editedItem));
       axios
      .post('actos/fiestas/grabar',bodyFormData2,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {

                this.alerteditar = true;
                this.fiestas = response.data;
                this.overlay = false
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
              this.overlay = false
                });
      } else {
        let Xmas95 = new Date(this.editedItem.fechaInicio+"T00:00:00");
        let eldia = Xmas95.getUTCDay();
        if(eldia ===0 ){
          eldia=7
        }
        let diaDt = this.dias.find(x=>x.id === eldia);
        var bodyFormData = new FormData();
        this.editedItem.dia=diaDt;
        this.editedItem.fechaInicio = this.formatDarete(new Date(this.editedItem.fechaInicio+"T00:00:00"));
        this.editedItem.horaPromotorCierre = this.lahora + ":" + this.elmin + ":00"
        if(this.editedItem.createdAt !== null){
          this.editedItem.createdAt = this.formatDateee(new Date(this.editedItem.createdAt))}else{
          this.editedItem.createdAt = this.formatDateee(new Date())
        }
        this.editedItem.temporada = this.temporada
        this.editedItem.cliente = this.editedItem.temporada.negocio.cliente
        this.editedItem.id = 0;
        this.editedItem.lat = 0
        this.editedItem.lng = 0
        bodyFormData.append("data",JSON.stringify(this.editedItem));

        axios
      .post('actos/fiestas/grabar',bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
                this.fiestas = response.data;
                this.alertnuevo = true;
                console.log(response);
          this.overlay = false
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.error(error);
              this.overlay = false
                });
      }
      this.close()
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    formTitle () {
      return this.editedIndex === -1 ? 'Nueva Fiesta' : 'Editar Fiesta'
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      negocios: "negocios",
      dias: "dias"
    })
  }
};
</script>
